import React from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../config";

const OTPinput = ({
  name,
  placeholder,
  value,
  type,
  onChange,
  onFocus,
  onPaste,
  autoFocus,
  errorText,
}) => {
  return (
    <OTPInputfield
      autoFocus={autoFocus}
      type={type}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      maxLength="1"
      onFocus={onFocus}
      onPaste={onPaste}
      errorText={errorText}
      inputmode="numeric"
    />
  );
};

export default OTPinput;
const OTPInputfield = styled.input`
  outline: none;
  width: 5rem;
  border: 1px solid ${Colors.white};
  border-radius: 2.5rem;
  padding: 0.75rem 0rem;
  background: transparent;
  text-align: center;
  color: ${Colors.white};
  :placeholder {
    color: ${Colors.white};
    opacity: 0.2;
  }
  @media only screen and (max-width: 500px) {
    width: 3rem;
  }
  ${(props) =>
    props.errorText &&
    css`
      border: 1px solid ${Colors.red};
    `}
`;
